import { createTheme } from '@mui/material/styles';
import Pretendard from '@/fonts/PretendardVariable.woff2';

export const MuiTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Pretendard';
          font-style: normal;
          font-display: swap;
          src: local('Pretendard'), url(${Pretendard}) format('woff2');
        }
      `,
    },
  },
  typography: {
    fontSize: 10,
    fontFamily: [
      // reference: https://github.com/orioncactus/pretendard?tab=readme-ov-file#font-family
      'Pretendard',
      '-apple-system',
      'BlinkMacSystemFont',
      'system-ui',
      'Roboto',
      '"Helvetica Neue"',
      '"Segoe UI"',
      '"Apple SD Gothic Neo"',
      '"Noto Sans KR"',
      '"Malgun Gothic"',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      'sans-serif',
    ].join(','),
    button: { textTransform: 'none' },
  },
});
